const iRPMBaseURL = process.env.REACT_APP_IRPM_BASE_URL
const iRPMAppName = process.env.REACT_APP_IRPM_APP_NAME
const iRPMProj = process.env.REACT_APP_IRPM_PROJ_NAME
const iRPMEnv = process.env.REACT_APP_IRPM_ENV

const retryLimit = 3
const backoffInterval = 3000

class AppException extends Error {
  constructor (code, message) {
    const fullMessage = message ? `${code}: ${message}` : code
    super(fullMessage)
    this.name = code
    this.code = code
    this.message = message
  }
}

const DataServices = {
  async sendGetRequest (url, iteration = 1, irpm=false) {
    const jwt = localStorage.getItem('jwt')
    const headers = {
      'Content-Type': 'application/json'
    }
    if (jwt != null && !this.isExpired(jwt)){
      headers["Authorization"] = jwt
    }else if (!irpm){
      this.go2safe();
    }
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers
      })
      if (!response.ok) {
        throw new AppException(response.status, await response.json())
      }
      return {
        status: "OK",
        data: await response.json()
      }
    }
    catch (error) {
      console.log(error, backoffInterval)
      if (iteration === retryLimit) {
        return {
          status: "ERROR",
          error,
          code: error.code,
          data: error.message
        }
      }

      return new Promise(resolve => {
        const delay = iteration * backoffInterval
        console.log(`Retry ${iteration}, delay at ${delay}`)
        setTimeout(() => {
          this.sendGetRequest(url, iteration + 1).then(resolve)
        }, delay)
      })
    }
  },
  async sendPostRequest (url, data, iteration = 1) {
    const jwt = localStorage.getItem('jwt')
    const headers = {
      'Content-Type': 'application/json'
    }
    if (jwt != null && !this.isExpired(jwt)){
      headers["Authorization"] = jwt
    }else{
      this.go2safe();
    }
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        mode: 'cors',
        body: JSON.stringify(data)
      })
      if (!response.ok) {
        throw new AppException(response.status, await response.json())
      }
      return {
        status: "OK",
        data: await response.json()
      }
    }
    catch (error) {
      console.log(error, backoffInterval)
      if (iteration === retryLimit) {
        return {
          status: "ERROR",
          error,
          code: error.code,
          data: error.message
        }
      }

      return new Promise(resolve => {
        const delay = iteration * backoffInterval
        console.log(`Retry ${iteration}, delay at ${delay}`)
        setTimeout(() => {
          this.sendPostRequest(url, data, iteration + 1).then(resolve)
        }, delay)
      })
    }
  },
  go2safe() {
    let name = encodeURIComponent(iRPMAppName)
    // eslint-disable-next-line 
    let callbackUrl = encodeURIComponent(window.location.origin + '/jwt/${jti}/${nounce}')
    let proj = iRPMProj
    let gate = iRPMBaseURL+'/console/safe.html'
    window.location.href = gate + '#/name/' + name + '/proj/' + proj + '/callback/' + callbackUrl
  },
  fetchJWT(jti, nounce) {
    return this.sendGetRequest(iRPMBaseURL+'/' + iRPMEnv + '/api/get-jwt/' + JSON.stringify({ jti: jti, nounce: nounce }),1,true)
  },
  isExpired(jwt) {
    let parts = jwt.split('.')
    let bodyEnc = parts[1]
    let base64 = bodyEnc.replace(/-/g, '+').replace(/_/g, '/')
    if (!base64) return true;
    let bodyStr = atob(base64)
    let body
    try {
      body = JSON.parse(bodyStr)
    }
    catch (e) {
      body = {}
    }
    let exp = body.exp

    if (!exp) return true;
    let now = Date.now();
    return now >= exp * 1000;
  },
  async sendiRPMRequest (endpoint, data = null, iteration = 1) {
    const url = `${iRPMBaseURL}/${iRPMEnv}/api/${endpoint}`
    const jwt = localStorage.getItem('jwt')
    const headers = {
      'Content-Type': 'application/json'
    }
    if (jwt != null && !this.isExpired(jwt)){
      headers["Authorization"] = jwt
    }else{
      this.go2safe();
    }
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        mode: 'cors',
        body: JSON.stringify(data)
      })
      if (!response.ok) {
        throw new AppException(response.status, await response.json())
      }
      return {
        status: "OK",
        data: await response.json()
      }
    }
    catch (error) {
      console.log(error, backoffInterval)
      if (iteration === retryLimit) {
        return {
          status: "ERROR",
          error,
          code: error.code,
          data: error.message
        }
      }

      return new Promise(resolve => {
        const delay = iteration * backoffInterval
        console.log(`Retry ${iteration}, delay at ${delay}`)
        setTimeout(() => {
          this.sendPostRequest(url, data, iteration + 1).then(resolve)
        }, delay)
      })
    }
  }
}

export default DataServices
